import { configureStore } from "@reduxjs/toolkit";
import  productsSlice  from "./product/slice";
import favoriteSlice  from "./favorite/slice";

const store = configureStore({
    reducer: {
        products: productsSlice.reducer,
        favorite: favoriteSlice.reducer
    }
})

export default store;